/// <amd-module name="Agile/Common/Constants/RoutingConstants" />
export namespace RouteParameters {
    export const Name = "name";
    export const Project = "project";
    export const Team = "team";
    export const Pivot = "pivot";
    export const Iteration = "iteration";
    export const TeamName = "teamName";
    export const BacklogLevel = "backlogLevel";

    /**
     * This parameter is not surfaced in the user-visible url but instead it's used for contribution constraints
     */
    export const ViewName = "viewname";
}

export namespace RouteContributions {
    export const SprintsContentRoute = "ms.vss-work-web.sprints-content-route";
    export const BacklogHubRoute = "ms.vss-work-web.backlogs-content-route";

    export const SprintDirectoryRoute = "ms.vss-work-web.sprints-directory-route";
}

export namespace SprintPivots {
    export const Taskboard = "taskboard";
}
